import React, { useEffect, useState } from 'react';
import HeaderBottom from '../../components/HomePage/HeaderBottom';
import MarginTop from '../../MarginTop';

const AddPaypalEmail = () => {
    const [email, setEmail] = useState([]);

    useEffect(() => {
        fetch(`https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/paypal-email`)
            .then((res) => res.json())
            .then((info) => setEmail(info));
    }, [email]);

    const handleEmailSection = (event) => {
        event.preventDefault();
        const paypalEmail = event.target.paypalEmail.value;

        const paypalAdded = {
            paypalEmail
        };

        fetch(`https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/add-email`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(paypalAdded),
        })
            .then((res) => res.json())
            .then(() => {
                alert('Paypal Email Added');
            });
    };

    return (
        <>
        <HeaderBottom></HeaderBottom>
            <section id="services" className="services-area  d-flex align-items-center justify-content-center">
                <div className="container">
                    <MarginTop></MarginTop>
                    <div className="row justify-content-center vh-100">
                        <div className="col-lg-8 col-md-8">
                            <h3 className="text-center mb-4">Add Paypal Email</h3>
                            <form className="contact-form" onSubmit={handleEmailSection}>
                                <div className="form-group ">
                                    <input
                                        type="email"
                                        className="form-control form-control-lg shadow-lg p-3 mb-3 bg-white rounded"
                                        name="paypalEmail"
                                        placeholder="Paypal Email"
                                        required
                                    />
                                </div>
                                <div className="text-center">
                                    <button type="submit" className="btn btn-primary btn-lg" data-animation="fadeInRight" data-delay=".8s">
                                        Add Paypal Email
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AddPaypalEmail;
